// 09-10 — mover a alguien de mesa o de grupo: se ve al instante y, si el servidor no lo acepta, vuelve atrás y lo dice.
// Tras moverlo, un aviso con «Deshacer» (Pau aprobó la maqueta el 09-10); deshacer no trae otro aviso. 05-11: sale de
// OficinaPage a un módulo para que el «Mover a ▸» de la fila de la lista (marco/AccionesAgente.tsx) haga exactamente lo
// mismo que el de la mesa (una acción, un sitio de verdad).
import { t } from '../../../i18n';
import { useToastStore } from '../../../stores/toast.store';
import type { OrdenMesas } from '../api';
import { mensajeError } from '../errores';
import { quien } from '../marco/estado';
import { deshacerMover, useOficinaStore } from '../store';

export function ordenarConDeshacer(projectId: string, orden: OrdenMesas, conDeshacer = true): void {
  const { contratados, grupos, ordenarMesas } = useOficinaStore.getState();
  const vuelta = conDeshacer ? deshacerMover(contratados, projectId, orden, quien, (id) => grupos.find((g) => g.id === id)?.nombre ?? '') : undefined;
  void ordenarMesas(projectId, orden)
    .then(() => {
      if (vuelta)
        useToastStore.getState().push({
          message: vuelta.mensaje,
          durationMs: 6_000,
          action: { label: t('oficinaV2.mesas.deshacer'), onClick: () => ordenarConDeshacer(projectId, vuelta.deshacer, false) },
        });
    })
    .catch((e: unknown) => useToastStore.getState().push({ message: mensajeError(e) }));
}
